import { render, staticRenderFns } from "./GuardsCreate.vue?vue&type=template&id=3de44517&"
import script from "./GuardsCreate.vue?vue&type=script&lang=js&"
export * from "./GuardsCreate.vue?vue&type=script&lang=js&"
import style0 from "./GuardsCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports